// Beer education dataset — 15 tipos con indicadores 1-10 + ficha técnica
export const BEER_TYPES = [
  {
    name: "Lager",
    slug: "lager",
    tagline: "La favorita del mundo",
    description: "Fermentación baja, limpia y refrescante. El arquetipo de la cerveza mundial — fácil de tomar, dorada y con final seco. Ideal para introducirse en la cultura cervecera.",
    color: "#F4C430",
    colorLabel: "Dorado claro (SRM 3-5)",
    grain: "Cebada malteada pale",
    hops: "Noble (Saaz, Hallertau)",
    abv: 4.8,
    calories: 215,
    tempC: "4 – 7°C",
    pairing: ["carnes ligeras", "pizzas", "ensaladas"],
    ratings: { amargor: 3, intensidad: 4, cuerpo: 4, frescura: 9, lupulo: 3, alcohol: 4 },
  },
  {
    name: "Pilsner",
    slug: "pilsner",
    tagline: "La checa original",
    description: "Lager noble y cristalina, nacida en Plzeň. Dorada brillante, con aroma herbal y amargor limpio persistente. Referente de elegancia rubia.",
    color: "#E8BE23",
    colorLabel: "Dorado intenso (SRM 4-6)",
    grain: "Cebada pilsner",
    hops: "Saaz, Tettnanger",
    abv: 5.0,
    calories: 215,
    tempC: "4 – 6°C",
    pairing: ["pescados blancos", "mariscos", "comida asiática"],
    ratings: { amargor: 5, intensidad: 5, cuerpo: 4, frescura: 8, lupulo: 6, alcohol: 4 },
  },
  {
    name: "IPA",
    slug: "ipa",
    tagline: "La perra amarga",
    description: "India Pale Ale. Explosión de lúpulo: cítricos, resinas y pino. Amargor marcado que equilibra la dulzura del malteado. Para los que mordieron la cultura cervecera.",
    color: "#D67A00",
    colorLabel: "Ámbar dorado (SRM 6-14)",
    grain: "Cebada pale + crystal",
    hops: "Americano (Citra, Mosaic, Cascade)",
    abv: 6.5,
    calories: 275,
    tempC: "7 – 10°C",
    pairing: ["hamburguesas", "comida picante", "quesos fuertes"],
    ratings: { amargor: 9, intensidad: 8, cuerpo: 6, frescura: 6, lupulo: 10, alcohol: 6 },
  },
  {
    name: "Hazy IPA",
    slug: "hazy-ipa",
    tagline: "Turbia y jugosa",
    description: "IPA neblinosa, amargor bajo y sensación jugosa a tropicales: mango, durazno, piña. La ola más sabrosa del craft moderno.",
    color: "#E89B2E",
    colorLabel: "Naranja opaco",
    grain: "Cebada pale + avena + trigo",
    hops: "Citra, Galaxy, Nelson Sauvin",
    abv: 6.2,
    calories: 260,
    tempC: "6 – 9°C",
    pairing: ["tacos", "cocina asiática", "quesos suaves"],
    ratings: { amargor: 4, intensidad: 7, cuerpo: 7, frescura: 8, lupulo: 9, alcohol: 6 },
  },
  {
    name: "Stout",
    slug: "stout",
    tagline: "Negra como la noche",
    description: "Negro intenso con espuma cremosa café. Notas de café tostado, chocolate oscuro y malta quemada. Para los kiltros que prefieren la oscuridad.",
    color: "#1A0F08",
    colorLabel: "Negro azabache (SRM 40+)",
    grain: "Cebada tostada + cebada negra",
    hops: "Inglés (Fuggle, East Kent Goldings)",
    abv: 5.5,
    calories: 260,
    tempC: "8 – 12°C",
    pairing: ["ostras", "postres de chocolate", "BBQ"],
    ratings: { amargor: 6, intensidad: 8, cuerpo: 9, frescura: 3, lupulo: 4, alcohol: 5 },
  },
  {
    name: "Porter",
    slug: "porter",
    tagline: "La hermana suave de la Stout",
    description: "Oscura pero sedosa. Notas de chocolate con leche, caramelo y café suave. Menos tostada que la stout, más accesible.",
    color: "#2B1810",
    colorLabel: "Marrón muy oscuro (SRM 30-40)",
    grain: "Cebada chocolate + pale",
    hops: "Inglés (Fuggle)",
    abv: 5.0,
    calories: 240,
    tempC: "8 – 12°C",
    pairing: ["carnes braseadas", "quesos azules", "postres"],
    ratings: { amargor: 5, intensidad: 7, cuerpo: 8, frescura: 3, lupulo: 3, alcohol: 5 },
  },
  {
    name: "Weissbier",
    slug: "weissbier",
    tagline: "Trigo bávaro",
    description: "Cerveza de trigo alemana, turbia y cremosa. Aroma a plátano y clavo por la levadura. Refrescante con cuerpo.",
    color: "#E3A857",
    colorLabel: "Dorado nublado",
    grain: "Trigo (50%+) + cebada",
    hops: "Mínimo",
    abv: 5.3,
    calories: 235,
    tempC: "5 – 8°C",
    pairing: ["salchichas bávaras", "ensaladas", "pretzels"],
    ratings: { amargor: 2, intensidad: 5, cuerpo: 6, frescura: 8, lupulo: 2, alcohol: 5 },
  },
  {
    name: "Sour",
    slug: "sour",
    tagline: "Ácida y viva",
    description: "Acidez pronunciada por fermentación con Lactobacillus o Brettanomyces. Notas a fruta fresca, vinagre suave y, a veces, madera. Refrescante y compleja.",
    color: "#D94E4E",
    colorLabel: "Varía (rojo, rosa, dorado)",
    grain: "Cebada + trigo + avena",
    hops: "Bajo",
    abv: 4.5,
    calories: 200,
    tempC: "4 – 8°C",
    pairing: ["ceviches", "quesos de cabra", "postres frutales"],
    ratings: { amargor: 2, intensidad: 8, cuerpo: 4, frescura: 10, lupulo: 2, alcohol: 4 },
  },
  {
    name: "Amber Ale",
    slug: "amber-ale",
    tagline: "El equilibrio ámbar",
    description: "Medio cuerpo, color ámbar cobrizo. Notas de caramelo y tostado balanceadas con lúpulo moderado. Versátil y fácil de maridar.",
    color: "#B5651D",
    colorLabel: "Ámbar cobrizo (SRM 10-17)",
    grain: "Cebada pale + crystal + Munich",
    hops: "Americano (Cascade)",
    abv: 5.5,
    calories: 245,
    tempC: "7 – 10°C",
    pairing: ["carnes rojas", "pastas con salsa roja", "cerdo"],
    ratings: { amargor: 5, intensidad: 6, cuerpo: 6, frescura: 5, lupulo: 5, alcohol: 5 },
  },
  {
    name: "Red Ale",
    slug: "red-ale",
    tagline: "Maltosa y roja",
    description: "Ale irlandesa/americana de color rojizo. Dominancia de malta caramelo, suave amargor, final seco. La compañera perfecta de un asado.",
    color: "#A03A15",
    colorLabel: "Rojo cobrizo (SRM 10-18)",
    grain: "Cebada + crystal rojo",
    hops: "Moderado (Willamette)",
    abv: 5.2,
    calories: 240,
    tempC: "7 – 10°C",
    pairing: ["asado", "empanadas", "hamburguesas"],
    ratings: { amargor: 4, intensidad: 6, cuerpo: 6, frescura: 5, lupulo: 4, alcohol: 5 },
  },
  {
    name: "Belgian Ale",
    slug: "belgian-ale",
    tagline: "Complejidad monástica",
    description: "Familia amplia (Blonde, Dubbel, Tripel, Quadrupel). Levadura belga que aporta especies, frutas, y ésteres complejos. Alta fermentación, alcohol elevado.",
    color: "#C5802B",
    colorLabel: "Dorado a marrón",
    grain: "Cebada pilsner + candy sugar",
    hops: "Belga/Inglés suave",
    abv: 8.0,
    calories: 315,
    tempC: "8 – 12°C",
    pairing: ["quesos fuertes", "estofados", "mariscos"],
    ratings: { amargor: 4, intensidad: 8, cuerpo: 7, frescura: 4, lupulo: 3, alcohol: 9 },
  },
  {
    name: "Bock",
    slug: "bock",
    tagline: "Lager fuerte alemana",
    description: "Lager robusta y maltosa originaria de Einbeck. Alcohol elevado, notas de caramelo, toffee y pan tostado. Para tardes de frío.",
    color: "#6B2F0E",
    colorLabel: "Marrón oscuro (SRM 14-22)",
    grain: "Cebada Munich + pilsner",
    hops: "Noble alemán",
    abv: 7.0,
    calories: 290,
    tempC: "7 – 10°C",
    pairing: ["carnes grasas", "cerdo ahumado", "caramelo"],
    ratings: { amargor: 4, intensidad: 8, cuerpo: 8, frescura: 3, lupulo: 3, alcohol: 8 },
  },
  {
    name: "Dunkel",
    slug: "dunkel",
    tagline: "Lager oscura bávara",
    description: "Lager suave y oscura, de cuerpo medio. Notas de chocolate, nueces y pan tostado. Fermentación baja que mantiene la limpieza.",
    color: "#4A2211",
    colorLabel: "Café oscuro (SRM 17-30)",
    grain: "Cebada Munich oscuro",
    hops: "Noble (Hallertau)",
    abv: 5.0,
    calories: 230,
    tempC: "7 – 10°C",
    pairing: ["salchichas", "pollo rostizado", "quesos semi-duros"],
    ratings: { amargor: 3, intensidad: 6, cuerpo: 6, frescura: 5, lupulo: 3, alcohol: 5 },
  },
  {
    name: "Golden Ale",
    slug: "golden-ale",
    tagline: "La accesible dorada",
    description: "Ale rubia ligera, aromática y fresca. Puerta de entrada al mundo craft para los que vienen de lagers industriales.",
    color: "#E8C547",
    colorLabel: "Dorado brillante (SRM 3-6)",
    grain: "Cebada pale",
    hops: "Americano suave",
    abv: 4.8,
    calories: 215,
    tempC: "5 – 8°C",
    pairing: ["ensaladas", "pescados", "ceviches"],
    ratings: { amargor: 4, intensidad: 4, cuerpo: 4, frescura: 8, lupulo: 4, alcohol: 4 },
  },
  {
    name: "Brown Ale",
    slug: "brown-ale",
    tagline: "La nuez inglesa",
    description: "Ale marrón de origen inglés. Sabores a avellanas, caramelo y chocolate suave. Equilibrada, sin estridencias.",
    color: "#5C2F10",
    colorLabel: "Marrón (SRM 15-22)",
    grain: "Cebada brown + crystal",
    hops: "Inglés (Fuggle)",
    abv: 5.2,
    calories: 240,
    tempC: "8 – 12°C",
    pairing: ["estofados", "carnes ahumadas", "quesos cheddar"],
    ratings: { amargor: 4, intensidad: 6, cuerpo: 6, frescura: 4, lupulo: 4, alcohol: 5 },
  },
];
